// extracted by mini-css-extract-plugin
export default {"root":"styles_root__ZDPzv","content":"styles_content__Xsquq","footText":"styles_footText__OI+n8"};